<div class="layout-row layout-align-start-center"
     (mouseenter)="isShowActions=true"
     (mouseleave)="isShowActions=false">

  <ng-container *ngIf="agent || (agentId && agentName)">

    <app-bringoz-state-link *ngIf="linkToAgentView"
                            class="flex text-ellipsis"
                            [state]="'agent.itinerary'"
                            [permission]="'driver.itinerary.get'"
                            [params]="{id: agent?.id || agentId}"
                            [text]="fullName || agentName">
    </app-bringoz-state-link>

    <app-bringoz-state-link *ngIf="!linkToAgentView"
                            class="flex text-ellipsis"
                            [state]="'agents-itinerary.list'"
                            [permission]="'driver.itinerary.get'"
                            [params]="{agentId :agent?.id || agentId}"
                            [text]="fullName || agentName">
    </app-bringoz-state-link>

  </ng-container>

  <span *ngIf="!agent && !agentId && !agentName">---</span>

  <app-text-copy-button *ngIf="agent && isShowCopyButton && isShowActions"
                        [isShowCopyBtn]="isShowActions"
                        [text]="fullName || agentName">

  </app-text-copy-button>

  <bringoz-button *ngIf="isShowFilterByButton && isShowActions"
                  type="tertiary"
                  (onClick)="filterByTypeEvent($event)">
    <bringoz-icon iconName="filter"></bringoz-icon>
  </bringoz-button>
</div>
